module.exports = __webpack_public_path__ + "img/ib_math.09e65574.gif";